/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";

export default function Model(props) {
  const group = useRef();

  const { nodes, materials, animations } = useGLTF(
    "/next_plant_v4_final4william.glb",
    "https://www.gstatic.com/draco/versioned/decoders/1.4.1/"
  );
  const { actions } = useAnimations(animations, group);
  useEffect(() => {
    Object.values(actions).forEach((v) => v.play());
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group
        position={[7.313150405884, 0.232974514365, -13.873805046082]}
        scale={0.521411597729}
      >
        <mesh
          geometry={nodes.Cube387.geometry}
          material={nodes.Cube387.material}
        />
        <mesh
          geometry={nodes.Cube387_1.geometry}
          material={nodes.Cube387_1.material}
        />
        <mesh
          name="Rauchwolke004"
          geometry={nodes.Rauchwolke004.geometry}
          material={nodes.Rauchwolke004.material}
          position={[-1.320363044739, 2.228092908859, -0.04475402832]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
        <mesh
          name="Rauchwolke005"
          geometry={nodes.Rauchwolke005.geometry}
          material={nodes.Rauchwolke005.material}
          position={[-1.324626922607, 2.209726333618, 0.28318977356]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
      </group>
      <group
        position={[7.228065490723, 0.232974693179, 6.58978843689]}
        scale={0.521411597729}
      >
        <mesh
          geometry={nodes.Cube386.geometry}
          material={nodes.Cube386.material}
        />
        <mesh
          geometry={nodes.Cube386_1.geometry}
          material={nodes.Cube386_1.material}
        />
        <mesh
          name="Rauchwolke012"
          geometry={nodes.Rauchwolke012.geometry}
          material={nodes.Rauchwolke012.material}
          position={[-1.320363044739, 2.228092908859, -0.044754981995]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
        <mesh
          name="Rauchwolke013"
          geometry={nodes.Rauchwolke013.geometry}
          material={nodes.Rauchwolke013.material}
          position={[-1.324627876282, 2.209726333618, 0.28318977356]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
      </group>
      <group
        position={[1.85563659668, 0.232974275947, 13.440837860107]}
        scale={0.521411597729}
      >
        <mesh
          geometry={nodes.Cube385.geometry}
          material={nodes.Cube385.material}
        />
        <mesh
          geometry={nodes.Cube385_1.geometry}
          material={nodes.Cube385_1.material}
        />
        <mesh
          name="Rauchwolke016"
          geometry={nodes.Rauchwolke016.geometry}
          material={nodes.Rauchwolke016.material}
          position={[-1.320364713669, 2.228092908859, -0.04475402832]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
      </group>
      <group
        position={[-7.708953857422, 0.232974514365, -13.88157081604]}
        scale={0.521411597729}
      >
        <mesh
          geometry={nodes.Cube384.geometry}
          material={nodes.Cube384.material}
        />
        <mesh
          geometry={nodes.Cube384_1.geometry}
          material={nodes.Cube384_1.material}
        />
        <mesh
          name="Rauchwolke006"
          geometry={nodes.Rauchwolke006.geometry}
          material={nodes.Rauchwolke006.material}
          position={[-1.320364952087, 2.228092908859, -0.04475402832]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
        <mesh
          name="Rauchwolke007"
          geometry={nodes.Rauchwolke007.geometry}
          material={nodes.Rauchwolke007.material}
          position={[-1.324627876282, 2.209726333618, 0.28318977356]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
      </group>
      <group
        position={[10.739391326904, 0.232974752784, 10.22497177124]}
        scale={0.521411597729}
      >
        <mesh
          geometry={nodes.Cube383.geometry}
          material={nodes.Cube383.material}
        />
        <mesh
          geometry={nodes.Cube383_1.geometry}
          material={nodes.Cube383_1.material}
        />
        <mesh
          name="Rauchwolke014"
          geometry={nodes.Rauchwolke014.geometry}
          material={nodes.Rauchwolke014.material}
          position={[-1.320363998413, 2.228092908859, -0.04475402832]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
        <mesh
          name="Rauchwolke015"
          geometry={nodes.Rauchwolke015.geometry}
          material={nodes.Rauchwolke015.material}
          position={[-1.324628829956, 2.209726333618, 0.28318977356]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
      </group>
      <group
        position={[6.935939788818, 0.232974633574, 2.435068130493]}
        scale={0.521411597729}
      >
        <mesh
          geometry={nodes.Cube382.geometry}
          material={nodes.Cube382.material}
        />
        <mesh
          geometry={nodes.Cube382_1.geometry}
          material={nodes.Cube382_1.material}
        />
        <mesh
          name="Rauchwolke010"
          geometry={nodes.Rauchwolke010.geometry}
          material={nodes.Rauchwolke010.material}
          position={[-1.320365905762, 2.228092670441, -0.044754505157]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
        <mesh
          name="Rauchwolke011"
          geometry={nodes.Rauchwolke011.geometry}
          material={nodes.Rauchwolke011.material}
          position={[-1.324628829956, 2.2097260952, 0.283189296722]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
      </group>
      <group
        position={[-1.021743774414, 0.232974514365, -9.761121749878]}
        scale={0.521411597729}
      >
        <mesh
          geometry={nodes.Cube381.geometry}
          material={nodes.Cube381.material}
        />
        <mesh
          geometry={nodes.Cube381_1.geometry}
          material={nodes.Cube381_1.material}
        />
        <mesh
          name="Rauchwolke008"
          geometry={nodes.Rauchwolke008.geometry}
          material={nodes.Rauchwolke008.material}
          position={[-1.32036447525, 2.228092908859, -0.04475402832]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
        <mesh
          name="Rauchwolke009"
          geometry={nodes.Rauchwolke009.geometry}
          material={nodes.Rauchwolke009.material}
          position={[-1.324628591537, 2.209726333618, 0.28318977356]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
      </group>
      <group
        position={[-10.917762756348, 0.232974275947, 4.076059341431]}
        scale={0.521411597729}
      >
        <mesh
          geometry={nodes.Cube380.geometry}
          material={nodes.Cube380.material}
        />
        <mesh
          geometry={nodes.Cube380_1.geometry}
          material={nodes.Cube380_1.material}
        />
        <mesh
          name="Rauchwolke021"
          geometry={nodes.Rauchwolke021.geometry}
          material={nodes.Rauchwolke021.material}
          position={[-1.324630737305, 2.209726333618, 0.28318977356]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
      </group>
      <group
        position={[-6.249336242676, 0.232974275947, 12.674297332764]}
        scale={0.521411597729}
      >
        <mesh
          geometry={nodes.Cube379.geometry}
          material={nodes.Cube379.material}
        />
        <mesh
          geometry={nodes.Cube379_1.geometry}
          material={nodes.Cube379_1.material}
        />
        <mesh
          name="Rauchwolke022"
          geometry={nodes.Rauchwolke022.geometry}
          material={nodes.Rauchwolke022.material}
          position={[-1.320364952087, 2.228092908859, -0.044755935669]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
        <mesh
          name="Rauchwolke023"
          geometry={nodes.Rauchwolke023.geometry}
          material={nodes.Rauchwolke023.material}
          position={[-1.324628829956, 2.209726333618, 0.28318977356]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
      </group>
      <group
        position={[-2.601173400879, 0.232974275947, 3.082774162292]}
        scale={0.521411597729}
      >
        <mesh
          geometry={nodes.Cube378.geometry}
          material={nodes.Cube378.material}
        />
        <mesh
          geometry={nodes.Cube378_1.geometry}
          material={nodes.Cube378_1.material}
        />
        <mesh
          name="Rauchwolke018"
          geometry={nodes.Rauchwolke018.geometry}
          material={nodes.Rauchwolke018.material}
          position={[-1.32036447525, 2.228092908859, -0.044754505157]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
        <mesh
          name="Rauchwolke019"
          geometry={nodes.Rauchwolke019.geometry}
          material={nodes.Rauchwolke019.material}
          position={[-1.324628829956, 2.209726333618, 0.283188819885]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
      </group>
      <group
        position={[11.488889694214, 0.232974454761, -6.332081317902]}
        scale={0.521411597729}
      >
        <mesh
          geometry={nodes.Cube377.geometry}
          material={nodes.Cube377.material}
        />
        <mesh
          geometry={nodes.Cube377_1.geometry}
          material={nodes.Cube377_1.material}
        />
        <mesh
          name="Rauchwolke002"
          geometry={nodes.Rauchwolke002.geometry}
          material={nodes.Rauchwolke002.material}
          position={[-1.320363998413, 2.228092670441, -0.04475402832]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
        <mesh
          name="Rauchwolke003"
          geometry={nodes.Rauchwolke003.geometry}
          material={nodes.Rauchwolke003.material}
          position={[-1.324628829956, 2.209726333618, 0.28318977356]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={0}
        />
      </group>
      <group
        position={[-5.200901031494, 0.082567669451, 9.081394195557]}
        scale={[0.04780517891, 0.032619539648, 0.032619539648]}
      >
        <mesh
          geometry={nodes.Cube001.geometry}
          material={nodes.Cube001.material}
        />
        <mesh
          geometry={nodes.Cube001_1.geometry}
          material={nodes.Cube001_1.material}
        />
        <mesh
          geometry={nodes.Cube001_2.geometry}
          material={materials["Baumgreen.001"]}
        />
        <mesh
          geometry={nodes.Cube001_3.geometry}
          material={nodes.Cube001_3.material}
        />
        <mesh
          geometry={nodes.Cube001_4.geometry}
          material={nodes.Cube001_4.material}
        />
        <mesh
          geometry={nodes.Cube001_5.geometry}
          material={materials["Solar_panel.001"]}
        />
      </group>
      <group
        position={[10.717478752136, 1.38683795929, -9.992213249207]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder001.geometry}
          material={nodes.Cylinder001.material}
        />
        <mesh
          geometry={nodes.Cylinder001_1.geometry}
          material={nodes.Cylinder001_1.material}
        />
        <mesh
          name="Windrad_5x026"
          geometry={nodes.Windrad_5x026.geometry}
          material={nodes.Windrad_5x026.material}
          position={[0.000007629395, 0, 0.000007629395]}
          rotation={[0.069813168695, 0, 0]}
        />
      </group>
      <group
        position={[-3.438056945801, 1.386838436127, 1.940257072449]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder105.geometry}
          material={nodes.Cylinder105.material}
        />
        <mesh
          geometry={nodes.Cylinder105_1.geometry}
          material={nodes.Cylinder105_1.material}
        />
        <mesh
          name="Windrad_5x038"
          geometry={nodes.Windrad_5x038.geometry}
          material={nodes.Windrad_5x038.material}
          position={[0.000003814697, 0, 0.000005722046]}
          rotation={[0.069813168695, 0, 0]}
        />
      </group>
      <group
        position={[6.014275550842, 1.386838674545, 1.013960838318]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder103.geometry}
          material={nodes.Cylinder103.material}
        />
        <mesh
          geometry={nodes.Cylinder103_1.geometry}
          material={nodes.Cylinder103_1.material}
        />
        <mesh
          name="Windrad_5x037"
          geometry={nodes.Windrad_5x037.geometry}
          material={nodes.Windrad_5x037.material}
          position={[0, 0, 0.000004768372]}
          rotation={[Math.PI / 4, 0, 0]}
        />
      </group>
      <group
        position={[-5.928518295288, 1.386838078499, -10.617630958557]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder089.geometry}
          material={nodes.Cylinder089.material}
        />
        <mesh
          geometry={nodes.Cylinder089_1.geometry}
          material={nodes.Cylinder089_1.material}
        />
        <mesh
          name="Windrad_5x030"
          geometry={nodes.Windrad_5x030.geometry}
          material={nodes.Windrad_5x030.material}
          position={[0.000007629395, 0, 0.000007629395]}
          rotation={[0.069813168695, 0, 0]}
        />
      </group>
      <group
        position={[6.87085723877, 1.386838674545, -2.161205530167]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder101.geometry}
          material={nodes.Cylinder101.material}
        />
        <mesh
          geometry={nodes.Cylinder101_1.geometry}
          material={nodes.Cylinder101_1.material}
        />
        <mesh
          name="Windrad_5x036"
          geometry={nodes.Windrad_5x036.geometry}
          material={nodes.Windrad_5x036.material}
          position={[0.000007629395, 0, 0.000007629395]}
          rotation={[0.069813168695, 0, 0]}
        />
      </group>
      <group
        position={[-2.014785766602, 1.386838078499, -13.465301513672]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder054.geometry}
          material={nodes.Cylinder054.material}
        />
        <mesh
          geometry={nodes.Cylinder054_1.geometry}
          material={nodes.Cylinder054_1.material}
        />
        <mesh
          name="Windrad_5x029"
          geometry={nodes.Windrad_5x029.geometry}
          material={nodes.Windrad_5x029.material}
          position={[0.000007629395, 0, 0]}
          rotation={[1.117010725386, 0, 0]}
        />
      </group>
      <group
        position={[1.414445877075, 1.386837720871, 10.851356506348]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder121.geometry}
          material={nodes.Cylinder121.material}
        />
        <mesh
          geometry={nodes.Cylinder121_1.geometry}
          material={nodes.Cylinder121_1.material}
        />
        <mesh
          name="Windrad_5x046"
          geometry={nodes.Windrad_5x046.geometry}
          material={nodes.Windrad_5x046.material}
          position={[0.000005722046, 0, 0]}
          rotation={[-2.199114615674, 0, 0]}
        />
      </group>
      <group
        position={[9.903680801392, 1.386837720871, 9.134809494019]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder117.geometry}
          material={nodes.Cylinder117.material}
        />
        <mesh
          geometry={nodes.Cylinder117_1.geometry}
          material={nodes.Cylinder117_1.material}
        />
        <mesh
          name="Windrad_5x044"
          geometry={nodes.Windrad_5x044.geometry}
          material={nodes.Windrad_5x044.material}
          position={[0.000022888184, 0, 0]}
          rotation={[0.069813168695, 0, 0]}
        />
      </group>
      <group
        position={[-7.101566314697, 1.386837482452, 11.602867126465]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder123.geometry}
          material={nodes.Cylinder123.material}
        />
        <mesh
          geometry={nodes.Cylinder123_1.geometry}
          material={nodes.Cylinder123_1.material}
        />
        <mesh
          name="Windrad_5x047"
          geometry={nodes.Windrad_5x047.geometry}
          material={nodes.Windrad_5x047.material}
          rotation={[-2.373647465573, 0, 0]}
        />
      </group>
      <group
        position={[6.171052932739, 1.386837720871, 11.294269561768]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder119.geometry}
          material={nodes.Cylinder119.material}
        />
        <mesh
          geometry={nodes.Cylinder119_1.geometry}
          material={nodes.Cylinder119_1.material}
        />
        <mesh
          name="Windrad_5x045"
          geometry={nodes.Windrad_5x045.geometry}
          material={nodes.Windrad_5x045.material}
          rotation={[0.069813168695, 0, 0]}
        />
      </group>
      <group
        position={[-11.781505584717, 1.386838436127, 2.635886192322]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder107.geometry}
          material={nodes.Cylinder107.material}
        />
        <mesh
          geometry={nodes.Cylinder107_1.geometry}
          material={nodes.Cylinder107_1.material}
        />
        <mesh
          name="Windrad_5x039"
          geometry={nodes.Windrad_5x039.geometry}
          material={nodes.Windrad_5x039.material}
          position={[0.000015258789, 0, 0.000005722046]}
          rotation={[1.291543552884, 0, 0]}
        />
      </group>
      <group
        position={[-10.021110534668, 1.386838197708, -9.199934005737]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder091.geometry}
          material={nodes.Cylinder091.material}
        />
        <mesh
          geometry={nodes.Cylinder091_1.geometry}
          material={nodes.Cylinder091_1.material}
        />
        <mesh
          name="Windrad_5x031"
          geometry={nodes.Windrad_5x031.geometry}
          material={nodes.Windrad_5x031.material}
          rotation={[0.593411995879, 0, 0]}
        />
      </group>
      <group
        position={[-11.629383087158, 1.386837482452, 13.438478469849]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder125.geometry}
          material={nodes.Cylinder125.material}
        />
        <mesh
          geometry={nodes.Cylinder125_1.geometry}
          material={nodes.Cylinder125_1.material}
        />
        <mesh
          name="Windrad_5x048"
          geometry={nodes.Windrad_5x048.geometry}
          material={nodes.Windrad_5x048.material}
          rotation={[0.069813168695, 0, 0]}
        />
      </group>
      <group
        position={[3.268446922302, 1.386838674545, -1.601609230042]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder099.geometry}
          material={nodes.Cylinder099.material}
        />
        <mesh
          geometry={nodes.Cylinder099_1.geometry}
          material={nodes.Cylinder099_1.material}
        />
        <mesh
          name="Windrad_5x035"
          geometry={nodes.Windrad_5x035.geometry}
          material={nodes.Windrad_5x035.material}
          position={[0.000007629395, 0, 0.000005722046]}
          rotation={[0.069813168695, 0, 0]}
        />
      </group>
      <group
        position={[-5.081632614136, 1.386838197708, -1.105177402496]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder097.geometry}
          material={nodes.Cylinder097.material}
        />
        <mesh
          geometry={nodes.Cylinder097_1.geometry}
          material={nodes.Cylinder097_1.material}
        />
        <mesh
          name="Windrad_5x034"
          geometry={nodes.Windrad_5x034.geometry}
          material={nodes.Windrad_5x034.material}
          position={[0.000007629395, 0, 0.000005722046]}
          rotation={[0.069813168695, 0, 0]}
        />
      </group>
      <group
        position={[-12.450639724731, 1.386838197708, -6.771430969238]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder093.geometry}
          material={nodes.Cylinder093.material}
        />
        <mesh
          geometry={nodes.Cylinder093_1.geometry}
          material={nodes.Cylinder093_1.material}
        />
        <mesh
          name="Windrad_5x032"
          geometry={nodes.Windrad_5x032.geometry}
          material={nodes.Windrad_5x032.material}
          position={[0, 0, 0.000007629395]}
          rotation={[0.069813168695, 0, 0]}
        />
      </group>
      <group
        position={[-11.602415084839, 1.386838436127, 6.876903533936]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder109.geometry}
          material={nodes.Cylinder109.material}
        />
        <mesh
          geometry={nodes.Cylinder109_1.geometry}
          material={nodes.Cylinder109_1.material}
        />
        <mesh
          name="Windrad_5x040"
          geometry={nodes.Windrad_5x040.geometry}
          material={nodes.Windrad_5x040.material}
          position={[0, 0, 0.000007629395]}
          rotation={[0.069813168695, 0, 0]}
        />
      </group>
      <group
        position={[0.79451751709, 1.386837482452, 15.509122848511]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder127.geometry}
          material={nodes.Cylinder127.material}
        />
        <mesh
          geometry={nodes.Cylinder127_1.geometry}
          material={nodes.Cylinder127_1.material}
        />
        <mesh
          name="Windrad_5x049"
          geometry={nodes.Windrad_5x049.geometry}
          material={nodes.Windrad_5x049.material}
          position={[0.000004768372, 0, -0.000015258789]}
          rotation={[1.117010725386, 0, 0]}
        />
      </group>
      <group
        position={[-9.333776473999, 1.386838436127, 10.199346542358]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder111.geometry}
          material={nodes.Cylinder111.material}
        />
        <mesh
          geometry={nodes.Cylinder111_1.geometry}
          material={nodes.Cylinder111_1.material}
        />
        <mesh
          name="Windrad_5x041"
          geometry={nodes.Windrad_5x041.geometry}
          material={nodes.Windrad_5x041.material}
          position={[-0.000007629395, 0, 0]}
          rotation={[1.815142309343, 0, 0]}
        />
      </group>
      <group
        position={[-8.618991851807, 1.386838197708, -2.185530662537]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder095.geometry}
          material={nodes.Cylinder095.material}
        />
        <mesh
          geometry={nodes.Cylinder095_1.geometry}
          material={nodes.Cylinder095_1.material}
        />
        <mesh
          name="Windrad_5x033"
          geometry={nodes.Windrad_5x033.geometry}
          material={nodes.Windrad_5x033.material}
          position={[0, 0, 0.000007629395]}
          rotation={[0.5061454926, 0, 0]}
        />
      </group>
      <group
        position={[5.744048118591, 1.386837482452, 14.911794662476]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder129.geometry}
          material={nodes.Cylinder129.material}
        />
        <mesh
          geometry={nodes.Cylinder129_1.geometry}
          material={nodes.Cylinder129_1.material}
        />
        <mesh
          name="Windrad_5x050"
          geometry={nodes.Windrad_5x050.geometry}
          material={nodes.Windrad_5x050.material}
          position={[0.000007629395, 0, -0.000015258789]}
          rotation={[2.897246872051, 0, 0]}
        />
      </group>
      <group
        position={[-6.160251617432, 1.386838436127, 10.190574645996]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder113.geometry}
          material={nodes.Cylinder113.material}
        />
        <mesh
          geometry={nodes.Cylinder113_1.geometry}
          material={nodes.Cylinder113_1.material}
        />
        <mesh
          name="Windrad_5x042"
          geometry={nodes.Windrad_5x042.geometry}
          material={nodes.Windrad_5x042.material}
          position={[0.000007629395, 0, -0.000007629395]}
          rotation={[0.541052132112, 0, 0]}
        />
      </group>
      <group
        position={[2.096662521362, 1.38683795929, 5.166440010071]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder115.geometry}
          material={nodes.Cylinder115.material}
        />
        <mesh
          geometry={nodes.Cylinder115_1.geometry}
          material={nodes.Cylinder115_1.material}
        />
        <mesh
          name="Windrad_5x043"
          geometry={nodes.Windrad_5x043.geometry}
          material={nodes.Windrad_5x043.material}
          position={[0.000003814697, 0, 0.000003814697]}
          rotation={[-2.391100750547, 0, 0]}
        />
      </group>
      <group
        position={[7.580208778381, 1.386838078499, -15.529329299927]}
        scale={0.088380992413}
      >
        <mesh
          geometry={nodes.Cylinder050.geometry}
          material={nodes.Cylinder050.material}
        />
        <mesh
          geometry={nodes.Cylinder050_1.geometry}
          material={nodes.Cylinder050_1.material}
        />
        <mesh
          name="Windrad_5x028"
          geometry={nodes.Windrad_5x028.geometry}
          material={nodes.Windrad_5x028.material}
          position={[0.000007629395, 0, 0]}
          rotation={[0.85521147055, 0, 0]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(
  "/next_plant_v3_final.glb",
  "https://www.gstatic.com/draco/versioned/decoders/1.4.1/"
);
